import React, { useMemo } from "react";
import { Tabs } from "@shared/ui/tabs";
import CertificationsTab from "../tabs/certifications/CertificationsTab";
import RatesTab from "../tabs/rates/RatesTab";
import SkillsTab from "../tabs/skills/SkillsTab";
import RolesTab from "../tabs/roles/RolesTab";
import { Award, Clock, Wrench, Users } from "lucide-react";

const FieldForceSettings = () => {
  // Create tab components using the custom Tabs pattern
  const tabComponents = useMemo(
    () => ({
      certification: {
        label: "Certifications",
        icon: <Award className="h-4 w-4" />,
        shortLabel: "Cert", // Short label for mobile
        component: (
          <div className="mt-0 animate-fade-in">
            <CertificationsTab />
          </div>
        ),
      },
      rate: {
        label: "Rates",
        icon: <Clock className="h-4 w-4" />,
        component: (
          <div className="mt-0 animate-fade-in">
            <RatesTab />
          </div>
        ),
      },
      skills: {
        label: "Skills",
        icon: <Wrench className="h-4 w-4" />,
        component: (
          <div className="mt-0 animate-fade-in">
            <SkillsTab />
          </div>
        ),
      },
      // roles: {
      //   label: "Roles",
      //   icon: <Users className="h-4 w-4" />,
      //   component: (
      //     <div className="mt-0 animate-fade-in">
      //       <RolesTab />
      //     </div>
      //   ),
      // },
    }),
    []
  );

  return (
    <div className="">
      {/* Settings Header */}
      <div className="mb-6">
        <h2 className="page-title">
          Field Force Configuration
        </h2>
        <p className="page-subtitle">
          Manage certifications, rates, skills, and roles for field technicians
        </p>
      </div>

      <Tabs
        className="w-full"
        defaultValue="certification"
        urlMapping={{
          certification: "certification",
          rate: "rate",
          skills: "skills",
          roles: "roles",
        }}
        idPrefix="fieldforce"
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-3 bg-gray-50 p-1 rounded-lg"
      />
    </div>
  );
};

export default FieldForceSettings;
